import { render, staticRenderFns } from "./PlaygroundTable.vue?vue&type=template&id=606e366f&scoped=true"
import script from "./PlaygroundTable.vue?vue&type=script&lang=js"
export * from "./PlaygroundTable.vue?vue&type=script&lang=js"
import style0 from "./PlaygroundTable.vue?vue&type=style&index=0&id=606e366f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606e366f",
  null
  
)

export default component.exports